{
  "title": "Federation",
  "subtitle": "A2A workstations — remotely controlled agent systems",
  "add": "Add",
  "loading": "Loading…",
  "empty": "No workstations registered yet",
  "add_first": "Add first workstation →",
  "delete_confirm": "Remove workstation?",
  "info_p1": "Registered workstations are reachable via ",
  "info_p2": ". The token is the target workstation's ",
  "info_p3": ".",
  "workstation": {
    "token_ok": "Token configured",
    "no_token": "No token",
    "tls_on": "TLS verify active",
    "tls_off": "TLS verify disabled (self-signed OK)",
    "refresh": "Reload A2A card",
    "enable": "Enable",
    "disable": "Disable",
    "personas": "Personas / Agents",
    "last_seen": "Last seen:",
    "no_card": "No A2A card — please check token and click Refresh",
    "tls_label": "Verify TLS certificate",
    "tls_hint": "Off for self-signed setups (LAN/Tailnet, --tls-auto)",
    "tls_on_label": "ON",
    "tls_off_label": "OFF",
    "tls_on_title": "Currently ON — TLS certificate chain is validated. Click to disable (only useful for self-signed peers on LAN/Tailnet).",
    "tls_off_title": "Currently OFF — certificate is NOT verified. Only safe on trusted networks (LAN, Tailnet). Click to enable verification again.",
    "audit_load": "Remote audit log",
    "audit_loading": "Loading…",
    "audit_empty": "No entries"
  },
  "add_dialog": {
    "title": "Add workstation",
    "subtitle": "Register an A2A-compatible workstation",
    "name_label": "Name",
    "name_hint": "Used as @ address:",
    "url_label": "URL",
    "url_hint": "Full URL including port.",
    "token_label": "Remote token (PROJEKTX_REMOTE_TOKEN)",
    "token_placeholder": "optional — for /remote/* access",
    "tls_label": "Verify TLS certificate",
    "tls_hint": "Off for self-signed setups (ProjektX --tls-auto, Tailnet, LAN). On for real CA-signed peers over public internet.",
    "tls_warn": "⚠ This URL looks like LAN/Tailnet — TLS verify is probably why the card is unreachable. Uncheck?",
    "save": "Add",
    "saving": "Saving…",
    "cancel": "Cancel",
    "error": "Error saving"
  },
  "clients": {
    "title": "Connected clients",
    "subtitle": "Config files for ProjektX and other clients",
    "add": "Connect new client",
    "loading": "Loading…",
    "empty": "No clients connected yet",
    "add_first": "Connect first client →",
    "delete_confirm": "Remove client \"{{name}}\"? The API key will be revoked.",
    "remove_title": "Remove client"
  },
  "new_client": {
    "title": "Connect new client",
    "name_label": "Client name",
    "name_placeholder": "e.g. ProjektX Phone, ProjektX Laptop",
    "hint": "Each client gets its own API key. The key is shown only once — cannot be retrieved after download.",
    "cancel": "Cancel",
    "create": "Generate config",
    "creating": "Creating…",
    "close": "Close",
    "download": "Download config",
    "error": "Error creating client",
    "success_prefix": "Config for",
    "success_suffix": "generated. Download the file now — the API key cannot be retrieved afterwards.",
    "tailscale_no_authkey": "— (Tailscale admin not configured)",
    "agentlink_not_configured": "— not configured"
  },
  "instances": {
    "title": "Datamining instances",
    "subtitle": "External Claude Code instances mirroring live into datamining",
    "add": "New instance",
    "loading": "Loading…",
    "empty": "No datamining instances yet",
    "sessions": "sessions",
    "last_activity": "last",
    "copy_agent_id": "Copy agent ID",
    "rotate_key": "Rotate API key",
    "delete": "Delete instance",
    "delete_confirm": "Delete instance \"{{name}}\"? User, agent and API key will be removed.",
    "rotate_confirm": "Rotate key for \"{{name}}\"? The old key will be invalidated.",
    "new_key_prompt": "New API key (one-time — copy now):"
  },
  "new_instance": {
    "title": "New datamining instance",
    "name_label": "Instance name",
    "name_placeholder": "e.g. joshua, claude-laptop",
    "model_label": "Model",
    "hint": "Creates user + agent + API key. The key is shown only once.",
    "cancel": "Cancel",
    "create": "Create instance",
    "creating": "Creating…",
    "close": "Close",
    "copy": "Copy config",
    "error": "Error creating instance",
    "success_prefix": "Instance",
    "success_suffix": "created. Copy the block now — the API key will not be shown again."
  },
  "peers": {
    "title": "Servers",
    "subtitle": "paired HydraHive servers (via Tailscale)",
    "pair": "Pair server",
    "empty": "No server paired yet",
    "pair_title": "Pair server",
    "step1": "1. Create this server's pairing code and paste it on the other server",
    "name_ph": "Name of this server",
    "url_hint": "Address under which the other server reaches this one – ideally the Tailscale IP.",
    "make_code": "Create code",
    "copy": "Copy",
    "copied": "Copied",
    "own_fp": "Fingerprint of this server:",
    "step2": "2. Paste the other server's pairing code here",
    "add": "Add partner",
    "error": "Action failed",
    "fp": "Fingerprint:",
    "status_pending": "waiting for confirmation",
    "status_active": "active",
    "status_blocked": "blocked",
    "block": "Block",
    "delete": "Remove",
    "delete_confirm": "Remove pairing with {{name}}?",
    "confirm_hint": "Compare fingerprints: read it on the other server under “Pair server” and type it here.",
    "confirm": "Confirm",
    "agents_hint": "The partner server may task these agents:",
    "auto_tools_title": "Runs tools without confirmation",
    "auto_tools_warning": "At least one released agent runs tools without confirmation. Tasks from the partner server then run unchecked – enable “Confirm tools” in these agents' settings.",
    "call_hint": "Call from the other server: ask_agent(\"<agent name or ID>@{{server}}\")"
  }
}
